import { gqlClient } from '../../components/AppProvider';
import { AppDispatch, AppThunk } from '../../store';
import { getErrorMessage } from '../../util/Common';
import { AddTransactionMapInput, RequestResult, UpdateTransactionMapDetailsInput } from '../../gql-types.generated';
import { queryMapList } from '../../gql/QueryMapsList';
import { fetchError, fetchMapListSuccess, captureDeleteMapStatus, incrementMapRequestsInFlight, decrementMapRequestsInFlight, captureUpdateMapStatus, captureAddMapStatus } from './MapsSlice';
import { mutationDeleteEntity } from '../../gql/MutationDeleteEntity';
import { GetTransactionMapInput, PagingResultModelOfTransactionMapModel } from '../../gql-types.generated';
import { mutationUpdateMapDetails } from '../../gql/MutationUpdateMapDetails';
import { mutationAddMap } from '../../gql/MutationAddMap';

export const fetchMapList = (
    filters?: GetTransactionMapInput
) =>
    async (dispatch: AppDispatch): Promise<void> => {
        dispatch(incrementMapRequestsInFlight());
        try {
            const mapList = await queryMapList(gqlClient, filters);
            if (mapList) {
                dispatch(fetchMapListSuccess(mapList as PagingResultModelOfTransactionMapModel));
            }
            dispatch(decrementMapRequestsInFlight());
        } catch (e) {
            dispatch(fetchError(e as Error));
            dispatch(decrementMapRequestsInFlight());
        }
    };

export const updateMapData = (dataToUpdate: UpdateTransactionMapDetailsInput): AppThunk =>
    async (dispatch: AppDispatch): Promise<void> => {
        try {
            const updateMapStatus = await mutationUpdateMapDetails(gqlClient, dataToUpdate);
               
            if (updateMapStatus) {
                if (updateMapStatus.result === RequestResult.Fail) {
                    dispatch(fetchError({ message: updateMapStatus.message } as Error));
                    getErrorMessage(updateMapStatus.message as string, updateMapStatus.errors, true, true);
                }
                dispatch(captureUpdateMapStatus(updateMapStatus));
            }
        } catch (e) {
            dispatch(fetchError(e as Error));
        }
    };

export const uploadNewMap = (dataToAdd: AddTransactionMapInput): AppThunk =>
    async (dispatch: AppDispatch): Promise<void> => {
        try {
            const addMapStatus = await mutationAddMap(gqlClient, dataToAdd);
            if (addMapStatus) {
                if (addMapStatus.result === RequestResult.Fail) {
                    dispatch(fetchError({ message: addMapStatus.message } as Error));
                    getErrorMessage(addMapStatus.message as string, addMapStatus.errors, true, true);
                }
                dispatch(captureAddMapStatus(addMapStatus));
            }
        } catch (e) {
            dispatch(fetchError(e as Error));
        }
    };

export const deleteMapData = (id: string): AppThunk =>
    async (dispatch: AppDispatch): Promise<void> => {
        try {
            const deleteMapStatus = await mutationDeleteEntity(gqlClient, {
                id,
                entityName: "TransactionMap"
            });
            if (deleteMapStatus) {
                if (deleteMapStatus.result === RequestResult.Fail) {
                    getErrorMessage(deleteMapStatus.message as string, deleteMapStatus.errors, true, true);
                }
                dispatch(captureDeleteMapStatus(deleteMapStatus));
            }
        } catch (e) {
            dispatch(fetchError(e as Error));
        }
    };